/* eslint-disable arrow-body-style */
// index.tsx
import React, { forwardRef } from 'react';
import './index.scss';
import SegmentCom from './SegmentCom';
import { getDimensionName } from '../AIContent/_utils';
import { IDimensionInfo, IMetricInfo, IShowFilterItem } from '../AIContent/hooks';

interface Props {
  onChange: (values: Record<string, string>, isMetrics: boolean) => void;
  dimensionInfo: IDimensionInfo[];
  filterInfoVal: { [key: string]: string; } | null;
  metricsInfo: IMetricInfo[];
  currentMetric: string;
  showFilters: IShowFilterItem[];
  showMetrics: IMetricInfo[];
}

const TabComponent = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { filterInfoVal, onChange, metricsInfo, currentMetric, dimensionInfo, showFilters, showMetrics } = props;
  return (
    <div ref={ref} className="dba-may-ask-tab-container">
      {
        showFilters?.map((item, index) => {
          const { data_key, value: valueList } = item || {};
          const dimensionName = getDimensionName(data_key, dimensionInfo);
          return <SegmentCom
            key={data_key + index}
            dataKey={data_key}
            name={dimensionName || data_key}
            // config={config}
            value={filterInfoVal?.[data_key] || ''}
            valueList={valueList}
            onChange={(value) => onChange(value, false)}
          />;
        })
      }
      <div>
        {
          showMetrics && <SegmentCom
            dataKey={'metrics'}
            name={'Metrics'} // 这里负责展示的metrics
            metricsInfo={metricsInfo}
            value={currentMetric}
            valueList={showMetrics}
            onChange={(value) => onChange(value, true)}
          />
        }
      </div>

    </div>
  );
});

export default TabComponent;